<script>

    import { toast } from 'bulma-toast'
    import { accountStore } from '../stores'

    import AccountsService from '../$services/accounts.service'
    import DateMethod from '../$methods/date.methods'
    import Spinner from '../$components/spinner.svelte'

    let loading = false
    let data = {}

    getAccountDetails()

    async function getAccountDetails() {

        data = {}

        loading = true
        const resp = await AccountsService.getAccountDetails($accountStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        data = resp.data
    }
    
</script>

<div class="title">Detalles</div>
<Spinner {loading} />

{#if !loading && $accountStore}
    <div class="table-container">
        <table class="table is-fullwidth">
            <tbody class="table-informative">
                <tr>
                    <th>Status del pago</th>
                    <td><b>{ $accountStore.status === 'paid' || $accountStore.status === 'free'? 'Pagada' : 'Pendiente' }</b></td>
                </tr>
                {#if $accountStore.status === 'paid' || $accountStore.status === 'free'}
                    <tr>
                        <th>Fecha de pago</th>
                        <td>{ DateMethod.dateTimeLarge($accountStore.payment) }</td>
                    </tr>
                {/if}
                <tr>
                    <th>Envíos realizados</th>
                    <td>{ $accountStore.shipments.length }</td>
                </tr>
                <tr>
                    <th>Envíos</th>
                    <td>
                        <div class="title"><b>${ data.shipments }</b></div>
                    </td>
                </tr>
                <tr>
                    <th>Cargos</th>
                    <td>
                        <div class="title"><b>${ data.charges }</b></div>
                    </td>
                </tr>
                <tr>
                    <th>Reembolsos</th>
                    <td>
                        <div class="title"><b>${ data.refunds }</b></div>
                    </td>
                </tr>
                <tr>
                    <th>Descuento</th>
                    <td>
                        <div class="title"><b>${ data.discount || 0 }</b></div>
                    </td>
                </tr>
                <tr>
                    <th>Total</th>
                    <td>
                        <div class="title"><b>${ data.shipments + data.charges - data.refunds - data.discount }</b></div>
                    </td>
                </tr>
                <tr>
                    <th>Inicio</th>
                    <td>{ DateMethod.dateTimeLarge($accountStore.activated) }</td>
                </tr>
                <tr>
                    <th>Corte</th>
                    <td>{ DateMethod.dateTimeLarge($accountStore.expired) }</td>
                </tr>
            </tbody>
        </table>
    </div>
{/if}